import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Edit2 } from "lucide-react";
import ImageUploader from "@/components/ImageUploader";

export default function TAdminCategories() {
  const [list, setList] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: "", description: "", image_url: "", icon: "" });

  const load = () => api.get("/tenant/categories").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing === "new") await api.post("/tenant/categories", form);
      else await api.put(`/tenant/categories/${editing}`, form);
      toast.success("Saved"); setEditing(null); load();
    } catch { toast.error("Failed"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/tenant/categories/${id}`); toast.success("Deleted"); load();
  };

  return (
    <div data-testid="tadmin-categories">
      <div className="flex flex-wrap justify-between items-end gap-3 mb-6">
        <div><div className="admin-overline">Catalog</div><h1 className="admin-heading text-3xl font-bold mt-1">Categories</h1></div>
        <button onClick={() => { setEditing("new"); setForm({ name: "", description: "", image_url: "", icon: "" }); }} className="bg-black text-white px-4 py-2.5 text-xs font-semibold uppercase tracking-wider inline-flex items-center gap-2" data-testid="tadmin-cat-new-btn">
          <Plus className="h-3.5 w-3.5" /> New
        </button>
      </div>

      {editing && (
        <form onSubmit={save} className="bg-white border border-neutral-200 p-4 sm:p-6 mb-6 grid md:grid-cols-2 gap-4">
          <div><label className="admin-overline">Name</label><input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full mt-1 border border-neutral-300 px-3 py-2.5 text-sm focus:outline-none focus:border-black" data-testid="tadmin-cat-form-name" /></div>
          <div className="md:row-span-2">
            <ImageUploader label="Category image" value={form.image_url} onChange={(url) => setForm({ ...form, image_url: url })} folder="categories" shape="square" testid="tadmin-cat-form-image" />
          </div>
          <div className="md:col-span-1"><label className="admin-overline">Description</label><textarea rows={3} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="w-full mt-1 border border-neutral-300 px-3 py-2.5 text-sm focus:outline-none focus:border-black" /></div>
          <div className="md:col-span-2 flex gap-2">
            <button type="submit" className="bg-black text-white px-5 py-2.5 text-xs font-semibold uppercase tracking-wider" data-testid="tadmin-cat-form-save">Save</button>
            <button type="button" onClick={() => setEditing(null)} className="border border-neutral-300 px-5 py-2.5 text-xs font-semibold uppercase tracking-wider">Cancel</button>
          </div>
        </form>
      )}

      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3" data-testid="tadmin-categories-grid">
        {list.map((c) => (
          <div key={c.id} className="bg-white border border-neutral-200 p-4 flex gap-3">
            <div className="h-16 w-16 bg-neutral-100 flex-shrink-0">{c.image_url && <img src={c.image_url} alt="" className="h-full w-full object-cover" />}</div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold break-words">{c.name}</div>
              <div className="text-xs text-neutral-500 line-clamp-2">{c.description}</div>
              <div className="flex gap-1 mt-2">
                <button onClick={() => { setEditing(c.id); setForm({ name: c.name, description: c.description, image_url: c.image_url, icon: c.icon }); }} className="icon-btn hover:bg-neutral-100" aria-label="Edit"><Edit2 className="h-3.5 w-3.5" /></button>
                <button onClick={() => remove(c.id)} className="icon-btn hover:bg-red-50 text-red-700" aria-label="Delete"><Trash2 className="h-3.5 w-3.5" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
